import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const VisaCardIcon = createSvgIcon(
  'VisaCardIcon',
  <>
    <g filter="url(#filter0_d_2163_3134)">
      <rect width="118" height="75" rx="4" fill={Color.Silver500} />
    </g>
    <rect y="10" width="118" height="12" fill="black" />
    <rect x="8" y="37" width="68" height="16" fill="white" />
    <path
      d="M88.9716 40.2727V49H87.9148V41.3807H87.8636L85.733 42.7955V41.7216L87.9148 40.2727H88.9716ZM91.4815 49V48.233L94.3622 45.0795C94.7003 44.7102 94.9787 44.3892 95.1974 44.1165C95.4162 43.8409 95.5781 43.5824 95.6832 43.3409C95.7912 43.0966 95.8452 42.8409 95.8452 42.5739C95.8452 42.267 95.7713 42.0014 95.6236 41.777C95.4787 41.5526 95.2798 41.3793 95.027 41.2571C94.7741 41.1349 94.4901 41.0739 94.1747 41.0739C93.8395 41.0739 93.5469 41.1435 93.2969 41.2827C93.0497 41.419 92.858 41.6108 92.7216 41.858C92.5881 42.1051 92.5213 42.3949 92.5213 42.7273H91.5156C91.5156 42.2159 91.6335 41.767 91.8693 41.3807C92.1051 40.9943 92.4261 40.6932 92.8324 40.4773C93.2415 40.2614 93.7003 40.1534 94.2088 40.1534C94.7202 40.1534 95.1733 40.2614 95.5682 40.4773C95.9631 40.6932 96.2727 40.9844 96.4972 41.3509C96.7216 41.7173 96.8338 42.125 96.8338 42.5739C96.8338 42.8949 96.7756 43.2088 96.6591 43.5156C96.5455 43.8196 96.3466 44.1591 96.0625 44.5341C95.7812 44.9062 95.3906 45.3608 94.8906 45.8977L92.9304 47.9943V48.0625H96.9872V49H91.4815ZM101.696 49.1193C101.134 49.1193 100.632 49.0227 100.192 48.8295C99.7543 48.6364 99.4063 48.3679 99.1477 48.0241C98.892 47.6776 98.7528 47.2756 98.7301 46.8182H99.804C99.8267 47.0994 99.9233 47.3423 100.094 47.5469C100.264 47.7486 100.487 47.9048 100.763 48.0156C101.038 48.1264 101.344 48.1818 101.679 48.1818C102.054 48.1818 102.386 48.1165 102.676 47.9858C102.966 47.8551 103.193 47.6733 103.358 47.4403C103.523 47.2074 103.605 46.9375 103.605 46.6307C103.605 46.3097 103.526 46.027 103.366 45.7827C103.207 45.5355 102.974 45.3423 102.668 45.2031C102.361 45.0639 101.986 44.9943 101.543 44.9943H100.844V44.0568H101.543C101.889 44.0568 102.193 43.9943 102.455 43.8693C102.719 43.7443 102.925 43.5682 103.072 43.3409C103.223 43.1136 103.298 42.8466 103.298 42.5398C103.298 42.2443 103.233 41.9872 103.102 41.7685C102.972 41.5497 102.787 41.3793 102.548 41.2571C102.313 41.1349 102.034 41.0739 101.713 41.0739C101.412 41.0739 101.128 41.1293 100.861 41.2401C100.597 41.348 100.381 41.5057 100.213 41.7131C100.045 41.9176 99.9545 42.1648 99.9403 42.4545H98.9176C98.9347 41.9972 99.0724 41.5966 99.331 41.2528C99.5895 40.9062 99.9276 40.6364 100.345 40.4432C100.766 40.25 101.227 40.1534 101.73 40.1534C102.27 40.1534 102.733 40.2628 103.119 40.4815C103.506 40.6974 103.803 40.983 104.01 41.3381C104.217 41.6932 104.321 42.0767 104.321 42.4886C104.321 42.9801 104.192 43.3991 103.933 43.7457C103.678 44.0923 103.33 44.3324 102.889 44.4659V44.5341C103.44 44.625 103.871 44.8594 104.18 45.2372C104.49 45.6122 104.645 46.0767 104.645 46.6307C104.645 47.1051 104.516 47.5312 104.257 47.9091C104.001 48.2841 103.652 48.5795 103.209 48.7955C102.766 49.0114 102.261 49.1193 101.696 49.1193Z"
      fill={Color.Dark500}
    />
    <rect
      x="81"
      y="36"
      width="29"
      height="18"
      rx="3"
      stroke={Color.Red300}
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_d_2163_3134"
        x="0"
        y="0"
        width="118"
        height="77"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.580392 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2163_3134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2163_3134"
          result="shape"
        />
      </filter>
    </defs>
  </>,
  {
    viewBox: '0 0 118 77',
    style: { height: '77px', width: '100%', fill: 'none' },
  },
);
